<div class="propero-home">
  <section id="home" class="ph-hero">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>
    <div class="ph-container ph-hero__grid">
      <div>
        <div class="ph-hero__badge">
          <span class="ph-hero__badge-dot" aria-hidden="true"></span>
          {{ 'DOCUMENTS.HERO_EYEBROW' | translate }}
        </div>
        <h1 class="ph-hero__title">{{ 'DOCUMENTS.TITLE' | translate }}</h1>
        <p class="ph-hero__subtitle">{{ 'DOCUMENTS.TITLE_DESCRIPTION_SHORT' | translate }}</p>
        <div class="ph-hero__actions">
          <a href="#catalog" class="ph-btn ph-btn--brand ph-btn--lg">{{ 'DOCUMENTS.CATALOG_TITLE' | translate }}</a>
          <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--outline ph-btn--lg">
            Propero Assistant
          </a>
        </div>
      </div>
      <div class="ph-hero__visual">
        <img src="assets/images/slider/2.png" alt="" loading="lazy" />
      </div>
    </div>
  </section>

  <section id="catalog" class="ph-section ph-section--muted ph-docs-catalog">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--center ph-docs-catalog__header">
        <h2 class="ph-section__title">{{ 'DOCUMENTS.CATALOG_TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'DOCUMENTS.CATALOG_LEAD' | translate }}</p>
      </div>

      <div class="ph-doc-grid ph-doc-grid--catalog">
        <article *ngFor="let doc of documentWidgets" class="ph-doc-card ph-doc-card--compact">
          <div class="ph-doc-card__row">
            <div class="ph-doc-card__icon" aria-hidden="true"><i class="lni" [ngClass]="doc.icon"></i></div>
            <div class="ph-doc-card__body">
              <div class="ph-doc-card__meta">
                <h3 class="ph-doc-card__title">{{ doc.titleKey | translate }}</h3>
                <span
                  class="ph-doc-card__price"
                  [class.ph-doc-card__price--free]="!isPaidDocument(doc.group)">
                  <ng-container *ngIf="isPaidDocument(doc.group); else freePrice">
                    {{ 'DOCUMENTS.PRICE_FROM' | translate }}
                    {{ getDocumentWidgetPrice(doc.group).price | number : '1.2-2' }}
                    {{ getDocumentWidgetPrice(doc.group).currency }}
                  </ng-container>
                  <ng-template #freePrice>{{ 'DOCUMENTS.PRICE_FREE' | translate }}</ng-template>
                </span>
              </div>
              <p class="ph-doc-card__text">{{ doc.shortKey | translate }}</p>
            </div>
          </div>

          <div class="ph-doc-formats">
            <button
              type="button"
              class="ph-doc-format"
              *ngIf="getDocumentPriceDetails(doc.group + '_pdf', 'pdf') as pdf"
              (click)="onFormatClick($event, doc.group + '_pdf')">
              <i class="lni lni-pdf" aria-hidden="true"></i>
              <span>PDF</span>
              <span class="ph-doc-format__price">{{ pdf.documentPrice | number : '1.2-2' }} {{ pdf.documentCurrency }}</span>
            </button>
            <button
              type="button"
              class="ph-doc-format"
              *ngIf="getDocumentPriceDetails(doc.group + '_docx', 'docx') as docx"
              (click)="onFormatClick($event, doc.group + '_docx')">
              <i class="lni lni-file" aria-hidden="true"></i>
              <span>DOCX</span>
              <span class="ph-doc-format__price">{{ docx.documentPrice | number : '1.2-2' }} {{ docx.documentCurrency }}</span>
            </button>
            <button
              type="button"
              class="ph-doc-format"
              *ngIf="getDocumentPriceDetails(doc.group + '_odt', 'odt') as odt"
              (click)="onFormatClick($event, doc.group + '_odt')">
              <i class="lni lni-text" aria-hidden="true"></i>
              <span>ODT</span>
              <span class="ph-doc-format__price">{{ odt.documentPrice | number : '1.2-2' }} {{ odt.documentCurrency }}</span>
            </button>
          </div>
        </article>
      </div>
    </div>
  </section>

  <section id="contact" class="ph-section ph-section--contact">
    <div class="ph-container ph-contact__grid">
      <div class="ph-contact__info">
        <h2 class="ph-contact__title">{{ 'HOME.SECTION_CONTACTUS_HEADING' | translate }}</h2>
        <p class="ph-contact__lead">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>
        <div class="ph-contact__channels">
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-phone"></i></div>
            <div>
              <div class="ph-contact__channel-label">Telefon</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_PHONE' | translate }}</div>
            </div>
          </div>
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-envelope"></i></div>
            <div>
              <div class="ph-contact__channel-label">Email</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_EMAIL' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
      <form #contactForm="ngForm" (ngSubmit)="send()" class="ph-contact__form" novalidate>
        <div class="ph-field">
          <label for="docs-name">{{ 'HOME.NAME' | translate }}</label>
          <input id="docs-name" type="text" name="name" [(ngModel)]="contactItem.subject" required [placeholder]="'HOME.NAME' | translate" />
        </div>
        <div class="ph-field">
          <label for="docs-email">{{ 'HOME.EMAIL' | translate }}</label>
          <input id="docs-email" type="email" name="email" [(ngModel)]="contactItem.email" required email [placeholder]="'HOME.EMAIL' | translate" />
        </div>
        <div class="ph-field">
          <label for="docs-message">{{ 'HOME.MESSAGE' | translate }}</label>
          <textarea id="docs-message" name="message" rows="4" [(ngModel)]="contactItem.content" required [placeholder]="'HOME.MESSAGE' | translate"></textarea>
        </div>
        <button type="submit" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg" [disabled]="contactForm.invalid || isLoading">
          <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
          <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
        </button>
        <p *ngIf="contactSuccess" class="ph-contact__success">Mesaj trimis! Te contactăm în curând.</p>
      </form>
    </div>
  </section>
</div>
